import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { DataGrid, GridColDef, GridOverlay, GridColParams, GridCellParams, GridPageChangeParams, GridBaseComponentProps } from '@material-ui/data-grid';
import Grid from '@material-ui/core/Grid';
import Pagination from '@material-ui/lab/Pagination';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import GpsNotFixedIcon from '@material-ui/icons/GpsNotFixed';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';
import SettingsIcon from '@material-ui/icons/Settings';
import Button from '@material-ui/core/Button';
import { IGetOffer } from '../../../interfaces/IGetOffer';
import './AnnouncementList.scss';
import UserContext from '../../../utils/UserContext';
import { permissionAdminModifyOffer, permissionAdminViewOfferDetail, permissionAdminConvocatoryCancelOffer } from '../../../utils/PermissionsVariables';
import { containsAny } from '../../../helpers/sharedFunctions';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';

const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #ced4da',
      fontSize: 14,
      padding: '5px 6px 10px 12px',
      height: '30px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
  }),
)(InputBase);

interface AnnouncementListProps{
    rows: Array<IGetOffer>;
    pageSize: number;
    onChanhePageSize: any;
    initPage: number;
    setInitPage:any;
    handleRowOffer: any;
    handleUpdate: any;
}

const AnnouncementList: React.FC<AnnouncementListProps> = ({ rows, pageSize, onChanhePageSize,  initPage, setInitPage, handleRowOffer, handleUpdate}) => {
    const userContext = React.useContext(UserContext);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [offerSelected, setOfferSelected] = useState<IGetOffer>(new IGetOffer());

    const statesDefinicion = [
        {id: 1, name: 'Cambiar estado a Convocatoria abierta', state: 'Convocatoria abierta'},
        {id: 2, name: 'Cambiar estado a Cancelada', state: 'Cancelada'},
    ]

    const statesConvocatoria = [
        {id: 1, name: 'Cambiar estado a Cancelada', state: 'Cancelada'},
    ]

    const columnsAnnouncement: GridColDef[] = [
        { field: 'jobTitle', headerName: 'Nombre del cargo en la empresa', width: 300, renderHeader: (params: GridColParams) => (
            <strong className="column-states">
                <span className="column-header-title">
                    {'Nombre del cargo en la empresa'}
                </span>
                <UnfoldMoreIcon fontSize="small" className="color-arrows"/>
            </strong>
          ), renderCell:(params: GridCellParams) => {
              return(
              <span className="name-cell">{params.value}</span>
        )} },
        { field: 'jobOfferStartDate', headerName: 'Fecha de publicación', width: 200, renderHeader: (params: GridColParams) => (
            <strong className="column-states">
                <span className="column-header-break">
                    Fecha de <br/> publicación
                </span>
                <UnfoldMoreIcon fontSize="small" className="color-arrows"/>
            </strong>
          ), renderCell:(params: GridCellParams) =>{
              const valueDate = moment((params.value)?.toString()).format('YYYY/MM/DD');
              return(
                  <span className="date-cell">{valueDate}</span>
                )
            }
        },
        { field: 'jobOfferEndDate', headerName: 'Fecha final', width: 200, renderHeader: (params: GridColParams) => (
            <strong className="column-states">
                <span className="column-header-break">
                    Fecha final
                </span>
                <UnfoldMoreIcon fontSize="small" className="color-arrows"/>
            </strong>
          ), renderCell:(params: GridCellParams) =>{
              const valueDate = moment((params.value)?.toString()).format('YYYY/MM/DD');
              return(
                  <span className="date-cell">{valueDate}</span>
                )
            }
        },
        { field: 'state', headerName: 'Estado', width: 300, renderHeader: (params: GridColParams) => (
            <strong className="column-states">
                <span className="column-header-title">
                {'Estado'}
                </span>
                <UnfoldMoreIcon fontSize="small" className="color-arrows"/>
            </strong>
          ), renderCell:(params: GridCellParams) => (
            <strong>
                {params.value === 'En definición' && <div className="active-state state-applicant-button-cell">En definición</div>}
                {params.value === 'Convocatoria abierta' && <div className="signed-up-state state-applicant-button-cell">Convocatoria Abierta</div>}
                {params.value === 'En Selección' && <div className="verified-state state-applicant-button-cell">En Selección</div>}
                {params.value === 'Finalizado' && <div className="rejected-state state-applicant-button-cell">Finalizado</div>}
                {params.value === 'Cancelada' && <div className="inactive-state state-applicant-button-cell">Cancelada</div>}
            </strong>
        ) },
        { field: 'Acción', headerName: 'Acciones', width: 100, sortable: false ,renderHeader: (params: GridColParams) => (
            <strong className="column-states">
                <span className="column-header-title">
                {'Acciones'}
                </span>
            </strong>
          ), renderCell:(params: GridCellParams) => (
            <>
                <Button aria-controls="simple-menu" aria-haspopup="true" onClick={(e)=>handleClick(e,params)}>
                    <SettingsIcon/>
                </Button>
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleCloseMenu}
                >
                    {
                        offerSelected.state === "En definición" && containsAny(permissionAdminConvocatoryCancelOffer,userContext.userPermissions) && statesDefinicion.map(item =>(
                            <MenuItem key={item.id} value={item.state} onClick={(e)=>{handleCloseMenu();handleRowOffer(item.state, offerSelected)}}>{item.name}</MenuItem>
                        ))
                    }
                    {
                        offerSelected.state === "Convocatoria abierta" && containsAny(permissionAdminConvocatoryCancelOffer,userContext.userPermissions) &&
                        statesConvocatoria.map(item =>(
                            <MenuItem key={item.id} value={item.state} onClick={(e)=>{handleCloseMenu();handleRowOffer(item.state, offerSelected)}}>{item.name}</MenuItem>
                        ))
                    }
                    {
                        offerSelected.state === "Convocatoria abierta" && containsAny(permissionAdminModifyOffer,userContext.userPermissions) &&
                        <MenuItem  onClick={(e)=>{handleCloseMenu(); handleUpdate('Edit', offerSelected) }}>
                            Editar oferta
                        </MenuItem>
                    }
                    {containsAny(permissionAdminViewOfferDetail,userContext.userPermissions) &&
                        <MenuItem onClick={(e)=>{handleCloseMenu();handleUpdate('See', offerSelected)}}>
                            Ver oferta
                        </MenuItem>
                    }
                </Menu>
            </>
        ) },
    ];

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>, params:GridCellParams) => {
        setAnchorEl(event.currentTarget);
        const user: IGetOffer = Object.assign(params.row);
        setOfferSelected(user)
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handlePage = (pageParams: GridPageChangeParams)=>{
        setInitPage(1)
    }

    return (
        <Grid container className="data-grid-container">
            <Grid item xs={12}>
                <DataGrid autoHeight className="data-grid-list" disableColumnMenu rows={rows} columns={columnsAnnouncement} pageSize={pageSize} pagination  density="compact" disableSelectionOnClick  onPageChange={(params:GridPageChangeParams)=>handlePage(params)}
                components={{
                        NoRowsOverlay: CustomNoRowsOverlay,
                        ColumnSortedAscendingIcon: customSortAsc,
                        ColumnSortedDescendingIcon: customSortDesc,
                        Footer:(props)=>CustomFooter(props, initPage, onChanhePageSize, pageSize)
                }}
                />
            </Grid>
        </Grid>
    );
}

const CustomFooter = (props: GridBaseComponentProps, initPage:number, onChanhePageSize?: any, valueRows?: number)=> {
    const { state, api } = props;
    const rowsPerPageOptions = [5,10,25,50,100];

    useEffect(()=>{
        if(initPage === 0){
            api.current.setPage(0)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[initPage]);

    return (
        <>
            <div className="footer-container">
                <div className="rows-number-container">
                    <span className="rows-number-text">Mostrar</span>
                    <Select
                        id="demo-simple-select"
                        value={valueRows}
                        onChange={onChanhePageSize}
                        input={<BootstrapInput/>}
                    >
                        {rowsPerPageOptions.map(item=>(
                            <MenuItem value={item}>{item}</MenuItem>
                        ))}
                    </Select>
                    <span className="rows-number-text">Registros</span>
                </div>
                <Pagination
                    className="pagination-container"
                    color="primary"
                    page={state.pagination.page+1}
                    count={state.pagination.pageCount}
                    onChange={(event, value) =>api.current.setPage(value-1)}
                    showFirstButton
                    showLastButton
                />
            </div>
        </>
    );
}

const CustomNoRowsOverlay = () => {
    return (
        <GridOverlay className="not-result-list">
            <GpsNotFixedIcon fontSize="large"/>
            <div className="not-results-text">Sin registros</div>
        </GridOverlay>
    );
}

const customSortAsc = (props: GridBaseComponentProps)=><KeyboardArrowUpIcon fontSize="small"/>
const customSortDesc = (props: GridBaseComponentProps)=><KeyboardArrowDownIcon fontSize="small"/>

export default AnnouncementList;